<template>
  <label class="d-flex" for="dynamic-select">
    <v-btn
      style="overflow-x: hidden; padding: 0 8px"
      color="allout-grey"
      elevation="0"
      height="40"
      :class="`${classes} allout-grey--text w-100 d-flex justify-space-between`"
      :disabled="disabled"
      outlined
      small
    >
      {{ optionsLookup[value] }}
      <v-icon>{{ icons.mdiMenuDown }}</v-icon>
    </v-btn>
    <select
      id="dynamic-select"
      :name="name"
      :value="value"
      :autofocus="autofocus"
      :disabled="disabled"
      :required="required"
      @input="$emit('input', $event.target.value)"
    >
      <option v-for="option in computedOptions" :key="option[0]" :value="option[0]">
        {{ option[1] }}
      </option>
    </select>
  </label>
</template>

<script>
import { mdiMenuDown } from '@mdi/js'
import { isArrayOfPairs } from '../../utils/validators'

export default {
  name: 'SelectInput',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      validator: isArrayOfPairs,
      required: true
    },
    emptyOption: {
      type: [Object, String],
      default: null
    },
    value: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      required: false,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    icons: {
      mdiMenuDown
    }
  }),
  computed: {
    // computedOptions: (vm) => vm.required
    //   ? vm.options.map(([value, label]) => ([value, `${label} *`]))
    //   : vm.options,
    computedOptions() {
      const options = this.options.concat()

      if (this.emptyOption !== null) {
        // We have an empty option for the select drop-down!
        switch (typeof this.emptyOption) {
          case 'string':
            // It's a plain old string so pass it through verbatim
            options.unshift(['', this.emptyOption])
            return options
          case 'object':
            // Hold up! It's an object so it is trying to leverage extended functionality
            if (this.emptyOption.$t) {
              // Cool we have an i18n string that needs to be fetched by the $t function
              options.unshift(['', this.$t(this.emptyOption.$t)])
              return options
            } else {
              throw new Error(`Unsupported emptyOption object ${this.emptyOption}`)
            }
        }
      }

      return options
    },
    optionsLookup() {
      return this.computedOptions.reduce((acc, [value, label]) => {
        acc[value] = label
        return acc
      }, {})
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  position: relative;

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    opacity: 0.0001;
    width: 100%;

    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
</style>
